import { INIT_TRACKING, TRACK_CLICK_STORE_DETAILS, TRACK_CLICK_SELECT_STORE, TRACK_CLICK_WANT_IT_DELIVERED, TRACK_CLICK_QUIT, TRACK_CLICK_FILTER, TRACK_SEARCH } from './types';
export var init = function init(config, stockFinderEnabled, activeFilter, skuQty) {
  return {
    type: INIT_TRACKING,
    config: config,
    stockFinderEnabled: stockFinderEnabled,
    activeFilter: activeFilter,
    skuQty: skuQty
  };
};
export var clickStoreDetails = function clickStoreDetails(storeId) {
  return {
    type: TRACK_CLICK_STORE_DETAILS,
    storeId: storeId
  };
};
export var clickSelectStore = function clickSelectStore(storeId, ctaLocation) {
  return {
    type: TRACK_CLICK_SELECT_STORE,
    storeId: storeId,
    ctaLocation: ctaLocation
  };
};
export var clickWantItDelivered = function clickWantItDelivered() {
  return {
    type: TRACK_CLICK_WANT_IT_DELIVERED
  };
};
export var clickQuit = function clickQuit() {
  return {
    type: TRACK_CLICK_QUIT
  };
};
export var clickFilter = function clickFilter(filter) {
  return {
    type: TRACK_CLICK_FILTER,
    filter: filter
  };
};
export var trackSearch = function trackSearch(searchTerm, updateState, searchBoxWasUsed) {
  return {
    type: TRACK_SEARCH,
    searchTerm: searchTerm,
    updateState: updateState,
    searchBoxWasUsed: searchBoxWasUsed
  };
};